var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showImagePreview)?_c('AppIcon',{attrs:{"name":"cards-field-image-preview","width":30,"height":30}}):_c('v-img',{attrs:{"max-width":"30","src":_vm.src,"width":30},on:{"error":function($event){_vm.showImagePreview = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }